import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AZURE_API_VERSION, DEFAULT_AZURE_POLICY_NAME } from 'src/app/shared/constants';

@Injectable({
  providedIn: 'root'
})
export class AzureOperationsService {

  constructor(private httpClient: HttpClient) { }

  /*
   * FOLLOWING METHOD WILL CREATE A NEW AZURE RELAY END POINT
   */
  public createAzureHybridConnection(subscriptionId: string,
    resourceGroupName: string, namespaceName: string,
    hybridConnectionName: string) {
    const address = `https://management.azure.com/subscriptions/${subscriptionId}/resourceGroups/${resourceGroupName}/providers/Microsoft.Relay/namespaces/${namespaceName}/hybridConnections/${hybridConnectionName}?api-version=${AZURE_API_VERSION}`;
    return this.httpClient.put(address, { "properties.requiresClientAuthorization": true });
  }

  public deleteAzureHybridConnection(subscriptionId: string,
    resourceGroupName: string, namespaceName: string,
    hybridConnectionName: string) {
    const address = `https://management.azure.com/subscriptions/${subscriptionId}/resourceGroups/${resourceGroupName}/providers/Microsoft.Relay/namespaces/${namespaceName}/hybridConnections/${hybridConnectionName}?api-version=${AZURE_API_VERSION}`;
    return this.httpClient.delete(address);
  }

  /*
   * FOLLOWING METHOD WILL CREATE A NEW AZURE NAMESPACE UNDER A GIVEN ACCOUNT
   */
  public createAzureNamespace(subscriptionId: string,
    resourceGroupName: string, namespaceName: string,
    location: string) {
    const address = `https://management.azure.com/subscriptions/${subscriptionId}/resourceGroups/${resourceGroupName}/providers/Microsoft.Relay/namespaces/${namespaceName}?api-version=${AZURE_API_VERSION}`;
    return this.httpClient.put(address, { "location": location });
  }


  /*
   * FOLLOWING WILL CHECK IF A NAMESPACE IS AVAILABLE ON THE AZURE OR NOT
   */
  public checkNamespaceAvailability(subscriptionId: string, namespace: string) {
    const address = `https://management.azure.com/subscriptions/${subscriptionId}/providers/Microsoft.Relay/checkNameAvailability?api-version=${AZURE_API_VERSION}`;
    return this.httpClient.post(address, { "name": `${namespace}` });
  }

  /*
   * FOLLOWING WILL GIVE US KEYNAME AND KEYVALUE REQUIRED TO CONNECT AN AZURE CONNECTION
   */
  public getKeysForANamespace(subscriptionId: string,
    namespace: string,
    resourceGroup: string) {
    const address = `https://management.azure.com/subscriptions/${subscriptionId}/resourceGroups/${resourceGroup}/providers/Microsoft.Relay/namespaces/${namespace}/authorizationRules/${DEFAULT_AZURE_POLICY_NAME}/listKeys?api-version=${AZURE_API_VERSION}`;
    return this.httpClient.post(address, {}, {});
  }




}
